import { Spinner } from '@sendible/design-system/src';
import { useTranslation } from 'react-i18next';
import { ModuleBody, NoProfilesContainer, NoProfilesIcon, NoProfilesTitle, NoProfilesDescription } from './index.styles';

export const ModuleLoadingSkeleton = () => {
  const { t } = useTranslation('reports');

  return (
    <ModuleBody>
      <NoProfilesContainer>
        <NoProfilesIcon>
          <Spinner size="sm" />
        </NoProfilesIcon>
        <NoProfilesTitle>{t('new_reports_loading_title')}</NoProfilesTitle>
        <NoProfilesDescription>{t('new_reports_loading_description')}</NoProfilesDescription>
      </NoProfilesContainer>
    </ModuleBody>
  );
};
